export { default } from "./follow-profile-button";
